import styled, { css } from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import { TableWithPaginationWrapper } from 'components/Table/styles'

export const TeamTableInnerWrapper = styled.div`
  @media ${theme.devices.tablet} {
    min-width: 1000px;
  }
`

export const TeamTableOuterWrapper = styled(TableWithPaginationWrapper)`
  @media ${theme.devices.tablet} {
    width: 100%;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
    border-radius: 8px;
  }
`

export const AvatarCellStyles = css`
  padding-right: 8px;
  padding-left: 32px;
`
export const NameCellStyles = css`
  padding-left: 8px;
`

export const CheckboxCellStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 8px;
`

export const CheckboxIcon = styled(Icon)<{ disabled?: boolean }>`
  color: ${(p) =>
    p.disabled ? theme.colors.disabledGrey : theme.colors.horizonOrange};

  :hover {
    opacity: ${(p) => (p.disabled ? 1 : 0.8)};
  }
`
